module.exports = __webpack_public_path__ + "media/apps/hero-mobile-illustration-c256465c.jpg";